import * as types from 'constants/actionTypes'
import get from 'lodash/get'

const initialState = {
  sceneNum: 0,
  activeMenuIndex: 0,
  rawLocation: {}
}

export default function (state = initialState, action) {
  switch (action.type) {

    case types.CHANGE_LOCATION:
      return {
        sceneNum: action.sceneNum,
        activeMenuIndex: action.activeMenuIndex,
        rawLocation: get(action, 'rawLocation', {})
      }

    case types.LOGOUT:
      return initialState

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/location.js